import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import { jsx as _jsx } from "react/jsx-runtime";
function ImageAttachmentPreview({
  imageFile
}) {
  const [imageDataUrl, setImageDataUrl] = useState('');
  useEffect(() => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setImageDataUrl(reader.result);
    });
    reader.readAsDataURL(imageFile);
  }, [imageFile]);
  if (!imageDataUrl) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIImage, {
    src: imageDataUrl
  });
}
ImageAttachmentPreview.displayName = 'ImageAttachmentPreview';
ImageAttachmentPreview.propTypes = {
  imageFile: PropTypes.instanceOf(File).isRequired
};
export default ImageAttachmentPreview;